type OverlayStyle = {
  left: number;
  top: number;
  width: number;
};

const PANEL_GAP = 8;
const PANEL_PADDING = 8;
const PANEL_WIDTH = 320;
const PANEL_HEIGHT_ESTIMATE = 392;

function capitalizeMonthLabel(value: string) {
  if (!value.length) {
    return value;
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
}

function resolveDatePickerPanelStyle(trigger: HTMLButtonElement | null): OverlayStyle | null {
  if (!trigger || typeof window === "undefined") {
    return null;
  }

  const rect = trigger.getBoundingClientRect();
  const width = Math.max(0, Math.min(PANEL_WIDTH, window.innerWidth - PANEL_PADDING * 2));
  const hasSpaceBelow = window.innerHeight - rect.bottom >= PANEL_HEIGHT_ESTIMATE + PANEL_GAP + 8;
  const top = hasSpaceBelow
    ? rect.bottom + PANEL_GAP
    : Math.max(PANEL_PADDING, rect.top - PANEL_GAP - PANEL_HEIGHT_ESTIMATE);
  const left = Math.min(
    Math.max(PANEL_PADDING, rect.left),
    Math.max(PANEL_PADDING, window.innerWidth - width - PANEL_PADDING)
  );

  return {
    left,
    top,
    width,
  };
}

export { capitalizeMonthLabel, resolveDatePickerPanelStyle };
